import { render, staticRenderFns } from "./FormEditContact.vue?vue&type=template&id=6ab991ea&"
import script from "./FormEditContact.vue?vue&type=script&lang=js&"
export * from "./FormEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports